module.exports = __webpack_public_path__ + "img/AG.7e594a00.svg";